export default {
  $autoDirty: true,
};
